import { Injectable } from "@angular/core";
import { AutopilotRepository } from "../../../domain/autopilot-repository";
import { AutopilotRule } from "../../../domain/rule";
import { HttpService } from "../../http/http";
import { AutopilotMapper } from "./autopilot.mapper";
import { UserService } from "../../../domain/user-service";
import { HttpParams } from "@angular/common/http";
import { Subject } from "rxjs";

@Injectable()
export class AutopilotRepositoryImpl implements AutopilotRepository {
  ruleCreated = new Subject<AutopilotRule>();
  ruleUpdated = new Subject<AutopilotRule>();

  constructor(
    private httpService: HttpService,
    private userService: UserService,
    private autopilotMapper: AutopilotMapper,
  ) {}

  getRule(id: string): Promise<AutopilotRule> {
    return this.httpService.get(`AutoPilot/${id}`).then((result: any) => {
      return this.autopilotMapper.mapGetGraphicsRuleResponse(result);
    });
  }

  createRule(rule: AutopilotRule): Promise<void> {
    let currentChannel;

    return this.userService
      .getCurrentChannel()
      .then((channel) => {
        currentChannel = channel;
      })
      .then(() => {
        return this.httpService.post(
          "AutoPilot/CreateRule",
          this.autopilotMapper.mapCreateOrUpdateRuleRequest(
            rule,
            currentChannel.id,
          ),
        );
      })
      .then((response) => {
        rule.id = response;
        this.ruleCreated.next(rule);
      });
  }

  updateRule(rule: AutopilotRule): Promise<void> {
    let currentChannel;

    return this.userService
      .getCurrentChannel()
      .then((channel) => {
        currentChannel = channel;
      })
      .then(() => {
        return this.httpService.post(
          "AutoPilot/UpdateRule",
          this.autopilotMapper.mapCreateOrUpdateRuleRequest(
            rule,
            currentChannel.id,
          ),
        );
      })
      .then(() => {
        this.ruleUpdated.next(rule);
      });
  }

  getAllRules(): Promise<AutopilotRule[]> {
    let currentChannel;

    return this.userService
      .getCurrentChannel()
      .then((channel) => {
        currentChannel = channel;
      })
      .then(() => {
        return this.httpService.get("Autopilot", {
          params: new HttpParams({
            fromString: `ChannelId=${currentChannel.id}`,
          }),
        });
      })
      .then((response) =>
        this.autopilotMapper.mapGetAllAutopilotRulesResponse(response),
      );
  }
  /*getAllVideoRules(): Promise<AutopilotRule[]> {
        return Promise.resolve([]);
    }*/

  setActiveState(ruleId: string, isActive: boolean) {
    let currentChannel;

    const commandUrl = isActive ? "activate" : "deactivate";

    return this.userService
      .getCurrentChannel()
      .then((channel) => {
        currentChannel = channel;
      })
      .then(() => {
        return this.httpService.post(`Autopilot/${commandUrl}`, {
          RuleId: ruleId,
        });
      });
  }

  markDeleted(ruleId) {
    let currentChannel;
    return this.userService
      .getCurrentChannel()
      .then((channel) => {
        currentChannel = channel;
      })
      .then(() => {
        return this.httpService.post("AutoPilot/DeleteRule", {
          RuleId: ruleId,
          ChannelId: currentChannel.id,
        });
      });
  }
}
